import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
// @ts-expect-error RecordPropType is not typed
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
export default ImmutablePropTypes.mapOf(ImmutablePropTypes.recordOf({
  data: RecordPropType('ResolvedAttachmentRecord'),
  status: PropTypes.string.isRequired
}), PropTypes.string.isRequired);